import React, { useState } from "react";
import axios from "axios";
import blogs from "../data/blogs";
import BlogCarousel from "../components/BlogCarousel";

export default function Flipkart() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [downloadUrl, setDownloadUrl] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
    setDownloadUrl(null);
    setError(null);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    setLoading(true);
    setError(null);
    setDownloadUrl(null);

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post(
        "https://meesho-label-crop-backend.onrender.com/crop",
        formData,
        { responseType: "blob" }
      );
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      setDownloadUrl(url);
    } catch (err) {
      setError("Crop failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="p-6 sm:p-10 text-center text-toast-blue flex-grow">
        <h2 className="text-2xl font-bold mb-6">Crop Your Flipkart Label at Ease</h2>
        <p className="text-red-500 font-semibold mb-4">This tool is under construction. Some features may not work as expected.</p>
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="mb-4"
        />
        <br />
        <button
          onClick={handleUpload}
          disabled={loading || !selectedFile}
          className="bg-toast-blue text-white px-6 py-2 rounded hover:bg-toast-red"
        >
          {loading ? "Cropping..." : "Crop PDF"}
        </button>
        {error && <p className="text-red-500 mt-4">{error}</p>}
        {downloadUrl && (
          <div className="mt-6">
            <p className="text-green-600 mb-2">Done!</p>
            <a
              href={downloadUrl}
              download={`Success_PDFCropEase_${new Date().toLocaleString().replace(/[/,: ]+/g, "_")}.pdf`}
              className="bg-green-600 text-white px-5 py-2 rounded hover:bg-green-700"
            >
              Download PDF
            </a>
          </div>
        )}
        
        <section className="mt-12">
          <h2 className="text-xl font-bold text-toast-blue mb-4 text-center">How It Works</h2>
          <div className="grid sm:grid-cols-3 gap-4 text-center text-toast-blue">
            <div>
              <div className="text-3xl mb-2">📤</div>
              <p>Upload your PDF file</p>
            </div>
            <div>
              <div className="text-3xl mb-2">✂️</div>
              <p>Tool processes your file</p>
            </div>
            <div>
              <div className="text-3xl mb-2">📥</div>
              <p>Download the result instantly</p>
            </div>
          </div>
        </section>
      </div>
      <div className="mt-10">
        <BlogCarousel />
      </div>
      <footer className="text-sm text-gray-500 mt-10 pt-4 border-t text-center">
      © 2025 by Drenx Technologies. All rights reserved. <br />
        📘 <a href="#" className="hover:underline">Facebook</a> &nbsp;
        📸 <a href="#" className="hover:underline">Instagram</a> &nbsp;
        ▶️ <a href="#" className="hover:underline">YouTube</a>
      </footer>
    </div>
  );
}